import { all, call, put, select, takeEvery,takeLatest, fork } from 'redux-saga/effects';
import { emitSagaEvent } from './sharedChannel'
import omit from 'lodash/omit';

import {
    actions,
    actionTypes, setFilterValue,
    setFuoriCartaceoEnabled
} from '../actions/filtersActions';
import {
    actions as productClassesActions,
    fetchProductClassAttributesSuccess,
} from '../actions/productClassesActions';
import { fetchItems } from '../actions/itemsActions';
import { fetchTree } from './sectorsSaga';

import * as api from '../api';
import * as constants from '../constants';
import { selectors as sectorsSelectors } from '../reducers/sectorsReducer';

import { delay } from 'redux-saga';
import { getIsChangingClassification, getIsLoadingFromLocalStorage } from '../reducers/pageStateReducer';
import { haveFuoriListinoCartaceoProperty } from '../helpers';
import { getApiPayload } from '../selectors/filterPayload';
import { changeBrandFilterSaga } from './filtersSaga/brandFilterSaga';
import { setFiltersStrategies } from './filtersSaga/strategies/setFiltersStrategies';
import { loadCustomFiltersBrandRelatedOptions, loadCustomFiltersOptions } from './filtersSaga/customFiltersSaga';
import { getFilters } from '../selectors/filterSelectors';
import pageStateActions from '../actions/pageStateActions';
import * as filterSelectors from '../selectors/filterSelectors';
import { getStoredFilters, updateLocalStorage } from '../utils/LocalStorageFilterUtils';
import { getCustomFiltersType } from './localStorageSagas/customFiltersSaga';
import { setLocalStorageFilters } from '../actions/localstorageActions';

let isBatchMode = false

function* setFilterValueSaga(action) {
    if (yield* shouldSkipProcessing()) {
        return
    }
    // Check if the api payload have products with fuori_listino_cartaceo
    yield* handleFilterFuoriCartaceo()

    // attendo che lo state sia aggiornato
    yield select((state) => state.filters.brands)

    // Non chiamiamo refreshFiltersValues qui perché viene già eseguito
    // tramite fork in fetchItemsSaga, evitando così doppie chiamate API
    yield put(fetchItems())
}

function* shouldSkipProcessing(){
    const isChangingClassification = yield select(getIsChangingClassification)
    return isBatchMode || isChangingClassification
}
// Check if the api payload have products with fuori_listino_cartaceo
function* handleFilterFuoriCartaceo() {
    const apiPayload = yield select(getApiPayload)
    const haveFuoriCartaceo = yield call(haveFuoriListinoCartaceoProperty, apiPayload)

    yield put(setFuoriCartaceoEnabled(haveFuoriCartaceo))
    // visto che dal backend mi arriva un array [true, false] mi costruisco l' oggetto qui
    const options = [
        {
            value: 'true',
            label: 'yes',
            code: 'true',
            extra: null,
        },
        {
            value: 'false',
            label: 'no',
            code: 'false',
            extra: null,
        }
    ]
    yield put(actions.setFilterOptions(constants.FUORI_CARTACEO_FILTER, options))
}

// Reloads filter options from api
export function* refreshFiltersValues(apiPayload = null) {
    emitSagaEvent('saga_start')

    //console.log('saga_start from refreshFiltersValues')

    const isLoadingFromLocalStorage = yield select(getIsLoadingFromLocalStorage)
    if (apiPayload === null) {
        apiPayload = yield select(getApiPayload);
    }

    yield fork(fetchTree);

    const brandApiPayload = omit(apiPayload, ['sigle_marca']);
    const classificationType = yield select(sectorsSelectors.getFilterValue);
    const isEtim = classificationType === constants.ETIM_CLASSIFICATION;

    const calls = [
        call(api.fetchBrandFilter, brandApiPayload),
        // call(api.fetchStatusFilter, apiPayload),
        call(api.fetchPriceRangeFilter, apiPayload),
        call(api.fetchListini, apiPayload),
        //call(api.fetchFuoriCartaceoFilter,apiPayload)
        // call(api.fetchClassificationTree, apiPayload)
    ];

    // Carichiamo le classi ETIM solo se la classificazione corrente è ETIM
    if (isEtim) {
        calls.push(call(api.fetchEtimClassFilter, apiPayload));
    }

    const results = yield all(calls);

    const brandsRes = results[0];
    const priceRangeRes = results[1];
    const listiniRes = results[2];
    const etimClassRes = isEtim ? results[3] : null;

    yield put(actions.setFilterOptions(constants.BRAND_FILTER, brandsRes.data));
    // yield put(actions.setFilterOptions(constants.STATUS_FILTER, statusRes.data));
    yield put(actions.setPriceRange(priceRangeRes.data));
    yield put(actions.setFilterOptions(constants.LISTINI_FILTER, listiniRes.data))

    if (etimClassRes) {
        yield put(productClassesActions.setProductClassOptions(etimClassRes.data));
    }
    //yield put(actions.setFilterOptions(constants.FUORI_CARTACEO_FILTER, fuoriCartaceoRes.data));
    // yield put(setTree(treeRes.data))

    // If there is only one brand selected in filters, we get also all the brand related filters
    // line, model, series and listini
    const sigleMarca = apiPayload.sigle_marca
    const shouldFetch = sigleMarca !== undefined && (sigleMarca.length === 1 || sigleMarca.toJS().length === 1)

    if (shouldFetch) {
        yield all([
            call(fetchFilterData, api.fetchStatusFilter, apiPayload, constants.STATUS_FILTER),
            call(fetchFilterData, api.fetchLineeFilter, apiPayload, constants.LINE_FILTER),
            call(fetchFilterData, api.fetchModelliFilter, apiPayload, constants.MODEL_FILTER),
            call(fetchFilterData, api.fetchSeriesFilter, apiPayload, constants.SERIES_FILTER),
            // fetchListini è già chiamata sopra nel blocco principale, non serve duplicarla
            call(loadCustomFiltersBrandRelatedOptions, apiPayload)
        ])
    }

    // Load custom filters options
    yield call(loadCustomFiltersOptions, apiPayload)

    emitSagaEvent('saga_end')
    //console.warn('saga_end from refreshFiltersValues')

}

export function* fetchFilterData(apiFn, apiPayload, filterName) {
    try {
        const res = yield call(apiFn, apiPayload);

        if(filterName === 'etim_features'){
            yield put(fetchProductClassAttributesSuccess(res))
        }else{
            yield put(actions.setFilterOptions(filterName, res.data));
        }

    } catch (err) {
        console.error(err);
    }
}

// EXPERIMENTAL
// a strategy that dispatch the right setValue based on filter key
export function* handleSetFiltersValueSaga(action){
    //console.warn('handleSetFiltersValueSaga called => ', action)

    const { filter, key, value } = action.payload

    const strategy = setFiltersStrategies[key] || setFiltersStrategies.default

    yield call(strategy, filter, key, value)
}

/**
 * Elimina dal local storage i filtri custom non piu compatibili
 *
 * Una volta eliminati aggiorna lo state con i nuovi filtri puliti dei filtri incompatibili in local storage
 * @returns {Generator<*, void, *>}
 */
export function* cleanNotExistingOptions()  {

    const isLoadingFromLocalStorage = yield select(getIsLoadingFromLocalStorage)

    if(isLoadingFromLocalStorage) {
        return
    }


    const filters = yield select(getFilters)

    // console.log('cleanNotExistingOptions', filters)
    const storedFilters = getStoredFilters()
    const storedCustomFilters = storedFilters?.custom_filters

    if(!storedCustomFilters) return

    const classeCategoriaScontoVenditaOptions = yield select(filterSelectors.getFilter, constants.CLASSE_CATEGORIA_SCONTO_VENDITA)
    const classeProdottoOptions = yield select(filterSelectors.getFilter, constants.CLASSE_PRODOTTO)
    const tipoArticoloOptions = yield select(filterSelectors.getFilter, constants.TIPO_ARTICOLO)
    const categoriaMerceologicaOptions = yield select(filterSelectors.getFilter, constants.CATEGORIA_MERCEOLOGICA)

    const filtersMap = [
        { type: constants.CLASSE_CATEGORIA_SCONTO_VENDITA, options: classeCategoriaScontoVenditaOptions.options },
        { type: constants.CLASSE_PRODOTTO, options: classeProdottoOptions.options },
        { type: constants.TIPO_ARTICOLO, options: tipoArticoloOptions.options },
        { type: constants.CATEGORIA_MERCEOLOGICA, options: categoriaMerceologicaOptions.options }
    ]

    for(const storedCustomFilter of storedCustomFilters) {
        // console.warn('customFilters current', customFilters[i])
        const {filterType, filterValue} = getCustomFiltersType(storedCustomFilter, filtersMap)

        if(!filterValue){
            updateLocalStorage('custom_filters', storedCustomFilter, 'remove')
        }

        // console.warn('filterType and filtervalue => ', filterType, filterValue)
    }

    const storedFiltersUpdated = getStoredFilters()

    yield put(setLocalStorageFilters({userFilters: storedFiltersUpdated}))

}

// piccolo remember: ascolto la action is loading from local storage e in cleanNotExistingOptions
// controllo il valore dallo state, quando è false eseguo la clean dei parametri
export default [
    takeEvery(actionTypes.SET_FILTER_VALUE, setFilterValueSaga),
    takeEvery(actionTypes.CHANGE_BRAND_FILTER_VALUE, changeBrandFilterSaga),
    takeEvery(actionTypes.REFRESH_FILTERS_VALUES, refreshFiltersValues),
    takeEvery(actionTypes.SET_FILTER_VALUES_HANDLER, handleSetFiltersValueSaga),
    takeLatest(pageStateActions.IS_LOADING_FROM_LOCAL_STORAGE, cleanNotExistingOptions)
]
